export enum RadarDetectionParamSource {
  HEADER = 'HEADER',
  BODY = 'BODY',
  QUERY = 'QUERY',
}
